










import { defineComponent, SetupContext } from '@vue/composition-api'
import Header from '@/components/Header/Header.vue'
import InputWord from '@/components/InputWord/InputWord.vue'
import { UseRouteComposition } from '@/composition/UseRouteComposition'

export default defineComponent({
  name: 'BaseLayout',
  components: { Header, InputWord },
  setup (props, context: SetupContext) {
    const router = UseRouteComposition(context)
    return {
      router
    }
  }
})
